import { FetchMeUser } from '@/modules/home/core/state/home.actions';
import { HomeState } from '@/modules/home/core/state/home.state';
import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, first, map, Observable, tap } from 'rxjs';
import {
  hasEnabledPermission,
  MeProfile,
} from '../services/profile/me-profile.model';

@Injectable({ providedIn: 'root' })
export class FeatureEditGuard implements CanActivate {
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.store.select(HomeState.getMe).pipe(
      tap((me) => {
        if (!me) this.store.dispatch(new FetchMeUser());
      }),
      filter((me): me is MeProfile => !!me),
      first(),
      map((me) => {
        const requiredPermission = route.data['editPermission'] as string;
        const viewPermission = route.data['viewPermission'] as
          | string
          | undefined;
        const targetPlatform = Number(route.queryParamMap.get('platform'));
        const isClientTarget =
          me.whitelabel?.id === 1 && targetPlatform > 0 && targetPlatform !== 1;
        const canViewClient =
          isClientTarget &&
          (me.masterAdmin === true ||
            (viewPermission != null &&
              hasEnabledPermission(me, viewPermission)));
        const canEdit = hasEnabledPermission(me, requiredPermission);

        return (isClientTarget ? canViewClient : canEdit)
          ? true
          : this.router.createUrlTree([route.data['redirectTo'] as string], {
              queryParams: { permissionDenied: true },
            });
      }),
    );
  }
}
